import { Box, Radio, useRadio, type UseRadioProps} from "@chakra-ui/react";

function RadioCard(props: UseRadioProps & { children?: React.ReactNode }) {
  const { getInputProps, getRadioProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getRadioProps();

  return (
    <Box as="label">
      <input {...input} />
      <Box
        {...checkbox}
        display="flex"
        gap="2"
        alignItems="center"
        cursor="pointer"
        borderWidth="1px"
        borderRadius="md"
        fontSize="sm"
        _checked={{
          bg: "primary.100a",
          color: "primary.500",
          borderColor: "primary.500",
        }}
        _disabled={{
          cursor: "not-allowed",
          opacity: 0.75
        }}
        px={3}
        py={1}
      >
        <Radio isChecked={props.isChecked} />
        {props.children}
      </Box>
    </Box>
  );
}

export default RadioCard;
